import { render, staticRenderFns } from "./Detail-Rental.vue?vue&type=template&id=73ac67d6&scoped=true"
import script from "./Detail-Rental.vue?vue&type=script&lang=js"
export * from "./Detail-Rental.vue?vue&type=script&lang=js"
import style0 from "./Detail-Rental.vue?vue&type=style&index=0&id=73ac67d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ac67d6",
  null
  
)

export default component.exports